module.exports = __webpack_public_path__ + "static/media/Anim_fra.60dfeaa4.fbx";